var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeryGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350,0C156.8,0,0,156.8,0,350s156.8,350,350,350c193.2,0,350-156.8,350-350S542.5,0,350,0L350,0z M350,628 C196.7,628,72.1,503.4,72.1,350.1C72.1,196.8,196.7,72.2,350,72.2c153.3,0,277.9,124.6,277.9,277.9S503.3,628,350,628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,252c0,24.7-20.1,44.8-44.8,44.8s-44.8-20.1-44.8-44.8s20.1-44.8,44.8-44.8S309.4,227.2,309.4,252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.6,252c0,24.7-20.1,44.8-44.8,44.8c-24.7,0-44.8-20.1-44.8-44.8s20.1-44.8,44.8-44.8 C461.5,207.2,481.6,227.2,481.6,252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.5,371c-10.5,74.2-74.2,131.6-151.2,131.6c-77,0-140.7-57.4-151.2-131.6h-54.6c10.5,103.6,98.7,184.8,205.1,184.8 S543.2,474.6,553.7,371H500.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryGood);
export default __webpack_public_path__ + "static/media/very-good.20560ef4ea37defb087d1ab3a1da0633.svg";
export { ForwardRef as ReactComponent };